/**
 * Stores build information. The string literals are replaced at compile time by `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-08-20",
    versionChannel: "nightly",
    buildDate: "2024-08-20T00:05:43.275Z",
    commitHash: "5b3c9722d5664b1240c4409e992d2816da08d612",
};
